export default __webpack_public_path__ + "assets/key.dc933ab.mp3";